import React, { FC, useState, useContext } from "react";
import { Box } from "@mui/material";
import useProjectStore from "common/store/ProjectStore";
import { SharedProjectContext } from "components/project/Project";
import theme from "common/theme/theme";

interface IProps {
  setSelected: (i: number, b: boolean) => void;
  setSelectMetadata: () => void;
  plotImageTransform: number;
}

const MultiSelectOverlay: FC<IProps> = (props) => {
  const { setSelected, setSelectMetadata, plotImageTransform } = props;

  const [drawing, setDrawing] = useState<boolean>(false);
  const [drawBox, setDrawBox] = useState<boolean>(false);

  const [xy1, setXy1] = useState({ x: -1, y: -1 });
  const [xy2, setXy2] = useState({ x: -1, y: -1 });

  const { activeNetwork, zoomPercent, activeGateway } = useProjectStore();

  const { setMultiSelect } = useContext(SharedProjectContext);

  const handleMouseDown = (event: React.MouseEvent) => {
    var boxElement = document.getElementById("drop-box");
    if (boxElement) {
      var box = boxElement.getBoundingClientRect();
      setXy1({
        x: (event.clientX - box.left) / (zoomPercent/100),
        y: (event.clientY - box.top) / (zoomPercent/100),
      });
    }
    setDrawing(true);
  };

  const handleMouseMove = (event: React.MouseEvent) => {
    var boxElement = document.getElementById("drop-box");
    if (boxElement) {
      setDrawBox(true);
      var box = boxElement.getBoundingClientRect();
      setXy2({
        x: (event.clientX - box.left) / (zoomPercent/100),
        y: (event.clientY - box.top) / (zoomPercent/100),
      });
    }
  };

  const handleMouseUp = (event: React.MouseEvent) => {
    if (drawing === true) {
      var boxElement = document.getElementById("drop-box");
      if (boxElement) {
        var box = boxElement.getBoundingClientRect();
        const x2 = (event.clientX - box.left) / (zoomPercent/100);
        const y2 = (event.clientY - box.top) / (zoomPercent/100);
        //get new xy
        // IF NOT CLICK
        if (xy1.x !== x2 && xy1.y !== y2) {
          // FIND SMALLXY AND BIGXY
          const smallX = xy1.x < x2 ? xy1.x : x2;
          const smallY = xy1.y < y2 ? xy1.y : y2;
          const bigX = xy1.x > x2 ? xy1.x : x2;
          const bigY = xy1.y > y2 ? xy1.y : y2;
          
          activeNetwork!.deviceInstances.forEach((device) => {
            var x = device.xPosition * plotImageTransform;
            var y = device.yPosition * plotImageTransform;
            if (smallX < x && x < bigX && smallY < y && y < bigY) {
              setSelected(device.deviceInstanceID, true);
            }
          });
          if(activeGateway) {
            var x = activeGateway.xPosition * plotImageTransform;
            var y = activeGateway.yPosition * plotImageTransform;
            if (smallX < x && x < bigX && smallY < y && y < bigY) {
              setSelected(activeGateway.deviceInstanceID, true);
            }
          }
          setSelectMetadata();
        }
      }

      setDrawing(false);
      setDrawBox(false);
      setXy1({ x: -1, y: -1 });
      setXy2({ x: -1, y: -1 });
      setMultiSelect(false);
    }
  };

  return (
    <Box
      sx={{
        top: 0,
        left: 0,
        position: "absolute",
        bgcolor: "transparent",
        zIndex: 5,
        height: "100%",
        width: "100%",
        "&:hover": {
          cursor: "crosshair",
        },
      }}
      onMouseDown={(e) => handleMouseDown(e)}
      onMouseMove={drawing ? (e) => handleMouseMove(e) : undefined}
      onMouseUp={(e) => handleMouseUp(e)}
    >
      <svg height="100%" width="100%">
        {drawing && drawBox && (
          <polygon
            points={`${xy1.x},${xy1.y} ${xy1.x},${xy2.y} ${xy2.x},${xy2.y} ${xy2.x},${xy1.y}`}
            stroke={theme.palette.secondary.light}
            strokeDasharray="5,5"
            fill={theme.palette.secondary.light}
            fillOpacity="0.5"
          ></polygon>
        )}
      </svg>
    </Box>
  );
};

export default MultiSelectOverlay;
